import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AttributeSection from "./components/AttributeSection";
import VariantSection from "./components/VariantSection";
import Select from "components/ui/Select";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategoriesService,
  getCategoryByIdService,
} from "redux/services/categories_service";
import ProductImageUpload from "./components/ProductImageUpload";
import Button from "components/ui/Button"; // تأكد من استيراد الزر من المسار الصحيح
import {
  createProductService,
  getAllProductsService,
  updateProductService,
} from "redux/services/products_sevice";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const EditProduct = ({}) => {
  const { t } = useTranslation();

  const { productInfo } = useSelector((state) => state.products);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoadingAction } = useSelector((state) => state.products);
  const { categoryList, subCategories } = useSelector(
    (state) => state.categories,
  );
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    category_id: productInfo?.category?.parent_category !== null
            ? productInfo?.category?.parent_category?.id
            : productInfo?.category?.id,
    subcategory_id:
      productInfo?.category?.parent_category !== null &&
      productInfo?.category?.id,
    price: "",
    price_after_discount: "",
    is_special: false,
    images: [],
    translations: {
      ar: { name: "", desc: "" },
    },
    attributes: [],
    variants: [],
    hasAttributes: true,
    quantity: "",
  });

  // ملء formData ببيانات productInfo لما يتوفر
  useEffect(() => {
    if (productInfo) {
      // تحويل الصور: افترض إن productInfo.images هي مصفوفة من URLs، حولها إلى objects
      const images =
        productInfo.images?.map((img, index) => ({
          id: Date.now() + index, // ID مؤقت
          file: null, // مش هناك file جديد، بس URL
          url: img.url || img, // افترض إنها URL أو object
          name: `Image ${index + 1}`,
          size: 0, // مش مهم
          isPrimary: index === 0, // افترض الأول primary
        })) || [];

      setFormData({
        category_id:
          productInfo?.category?.parent_category !== null
            ? productInfo?.category?.parent_category?.id
            : productInfo?.category?.id,
        subcategory_id: productInfo?.category?.id,
        price: productInfo?.price || "",
        price_after_discount: productInfo?.price_after_discount || "",
        is_special: productInfo?.is_special || false,
        images,
        translations: productInfo.translations || {
          ar: { name: "", desc: "" },
        },
        attributes: productInfo?.attributes || [],
        variants:
          productInfo?.attributes?.length !== 0 && productInfo?.variants
            ? productInfo.variants.map((variant) => ({
                quantity: variant.quantity.toString(), // تحويل إلى string
                values: variant.values.map((val) => val.translations.ar.value), // استخراج القيم كسلاسل
              }))
            : [],
        hasAttributes: productInfo?.attributes?.length > 0 ? true : false,
        quantity:
          productInfo?.attributes?.length == 0
            ? productInfo?.variants[0]?.quantity
            : "",
      });

      if (productInfo?.category?.parent_category !== null) {
        dispatch(
          getCategoryByIdService(productInfo.category?.parent_category?.id),
        ).then(() => {
          setFormData((prev) => ({
            ...prev,
            subcategory_id: productInfo?.category?.id,
          }));
        });
      }
    }
  }, [productInfo, dispatch]);

  useEffect(() => {
    console.log(subCategories);
  }, [subCategories]);

  const handleInputChange = (field, value) => {
    if (field.includes("translations")) {
      const [lang, key] = field.split(".").slice(1);
      setFormData((prev) => ({
        ...prev,
        translations: {
          ...prev.translations,
          [lang]: { ...prev.translations[lang], [key]: value },
        },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
    console.log(formData);
  };

  useEffect(() => {}, [formData, productInfo]);

  const handleDeleteVariant = (index) => {
    setFormData((prev) => ({
      ...prev,
      variants: prev.variants.filter((_, i) => i !== index),
    }));
  };
  const handleUpdateVariant = (index, updatedVariant) => {
    setFormData((prev) => ({
      ...prev,
      variants: prev.variants.map((v, i) => (i === index ? updatedVariant : v)),
    }));
  };

  const handleAddAttribute = (attribute) => {
    setFormData((prev) => ({
      ...prev,
      attributes: [...prev.attributes, attribute],
    }));
  };

  const handleAddVariant = (variant) => {
    setFormData((prev) => ({
      ...prev,
      variants: [...prev.variants, variant],
    }));
  };
  const handleUpdateAttribute = (index, updatedAttribute) => {
    setFormData((prev) => ({
      ...prev,
      attributes: prev.attributes.map((attr, i) =>
        i === index ? updatedAttribute : attr,
      ), // map: يبدل العنصر اللي i === index بالجديد
    }));
  };

  const handleDeleteAttribute = (index) => {
    setFormData((prev) => ({
      ...prev,
      attributes: prev.attributes.filter((_, i) => i !== index), // filter: يشيل العنصر اللي i === index
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("formData", formData);
    //  console.log(formData);

    try {
      const formData2 = new FormData();

      // Append basic product data
      formData2.append(
        "category_id",
        formData.subcategory_id !== "" && formData.subcategory_id !== undefined
          ? formData.subcategory_id
          : formData.category_id,
      );
      formData2.append("price", formData.price);
      formData2.append("price_after_discount", formData.price_after_discount);
      formData2.append("is_special", formData.is_special ? "1" : "0");
      // formData2.append("_method", "PUT");
      !formData.hasAttributes &&
        formData2.append("quantity", parseInt(formData.quantity, 10));

      // Append translations
      Object.keys(formData?.translations).forEach((lang) => {
        Object.keys(formData.translations[lang]).forEach((key) => {
          formData2.append(
            `translations[${lang}][${key}]`,
            formData.translations[lang][key],
          );
        });
      });

      // Process images (فقط الجديدة، اللي لها file)
      formData?.images?.forEach((im, index) => {
        if (im.file) {
          // فقط لو في file جديد
          formData2.append(`images[${index + 1}]`, im.file);
        }
      });

      // Process attributes
      formData.hasAttributes
        ? formData?.attributes?.forEach((attr, index) => {
            formData2.append(
              `attributes[${index + 1}][translations][ar][name]`,
              attr?.translations?.ar?.name,
            );

            attr?.values?.forEach((val, valIndex) => {
              if (val) {
                formData2.append(
                  `attributes[${index + 1}][values][${
                    valIndex + 1
                  }][translations][ar][value]`,
                  val?.translations?.ar?.value,
                );
              }
            });
          })
        : formData2.append(`attributes`, []);

      // Process variants
      formData.hasAttributes &&
        formData.variants.forEach((variant, index) => {
          console.log("varients");
          formData2.append(
            `variants[${index + 1}][quantity]`,
            variant.quantity,
          );
          variant?.values?.forEach((val, valIndex) => {
            formData2.append(
              `variants[${index + 1}][values][${valIndex + 1}]`,
              val,
            );
          });
        });

      console.log("API Request Data:", formData2);

      // استدعاء update بدلاً من create
      dispatch(
        updateProductService({ id: productInfo.id, formData: formData2 }),
      ).then((response) => {
        console.log(response);
        if (response?.payload?.status == 200) {
          toast.success(t("product_updated_success"));
          dispatch(getAllProductsService({ page: 1 }));
          navigate("/product-catalog-management");
        }
      });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors && typeof errors === "object") {
        // استخراج كل مصفوفات الرسائل ودمجها في مصفوفة واحدة
        const allErrors = Object.values(errors).flat();
        allErrors.forEach((msg) => toast.warn(msg));
      } else {
        toast.error(t("generalError"));
      }
    } finally {
      setLoading(false);
    }
  };

  const handleHasAttributesChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      hasAttributes: value,
      ...(value ? {} : { attributes: [] }),
    }));
  };

  const handleSetQuantity = (value) => {
    setFormData((prev) => ({
      ...prev,
      quantity: value,
    }));
  };

  useEffect(() => {
    dispatch(getAllCategoriesService({ page: 1 }));
  }, [dispatch]);

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">{t("edit_product_title")}</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Basic Information Section */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">
            {t("basic_information")}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="category"
                className="block text-sm font-semibold text-gray-800 mb-2"
              >
                {t("category_label")}
              </label>
              <Select
                name="category_id"
                value={formData.category_id}
                onChange={(value) => {
                  dispatch(getCategoryByIdService(value));
                  handleInputChange("category_id", value);
                }}
                options={categoryList.map((category) => ({
                  value: category.id,
                  label: category?.translations?.ar?.name,
                }))}
                placeholder={t("select_category_placeholder")}
                required
              />
            </div>

            <div>
              <label
                htmlFor="category"
                className="block text-sm font-semibold text-gray-800 mb-2"
              >
                {t("subCategoriesOf")}
              </label>
              <Select
                name="subcategory_id"
                value={formData.subcategory_id}
                onChange={(value) => handleInputChange("subcategory_id", value)}
                options={subCategories.map((category) => ({
                  value: category.id,
                  label: category?.translations?.ar?.name,
                }))}
                placeholder={t("select_subcategory_placeholder")}
                //  required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                {t("price_label")}
              </label>
              <input
                type="number"
                value={formData.price}
                onChange={(e) => handleInputChange("price", e.target.value)}
                className="w-full px-3 py-2 border rounded"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                {t("price_after_discount_label")}
              </label>
              <input
                type="number"
                value={formData.price_after_discount}
                onChange={(e) =>
                  handleInputChange("price_after_discount", e.target.value)
                }
                className="w-full px-3 py-2 border rounded"
              />
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                id="is_special"
                checked={formData.is_special}
                onChange={(e) =>
                  handleInputChange("is_special", e.target.checked)
                }
                className="mr-2"
              />
              <label htmlFor="is_special" className="text-sm font-medium">
                {t("is_special_label")}
              </label>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium mb-1">
                {t("product_name_ar")}
              </label>
              <input
                type="text"
                value={formData?.translations?.ar?.name}
                onChange={(e) =>
                  handleInputChange("translations.ar.name", e.target.value)
                }
                className="w-full px-3 py-2 border rounded"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                {t("description_ar")}
              </label>
              <textarea
                value={formData?.translations?.ar?.desc}
                onChange={(e) =>
                  handleInputChange("translations.ar.desc", e.target.value)
                }
                className="w-full px-3 py-2 border rounded"
                rows={3}
              />
            </div>
          </div>
        </div>

        {/* Product Images Section */}
        <ProductImageUpload
          images={formData.images}
          onChange={(images) => handleInputChange("images", images)}
        />

        {/* Attributes Section */}
        <AttributeSection
          attributes={formData?.attributes}
          onAddAttribute={handleAddAttribute}
          hasAttributes={formData?.hasAttributes}
          onHasAttributesChange={handleHasAttributesChange}
          quantity={formData?.quantity}
          onSetQuantity={handleSetQuantity}
          onDeleteAttribute={handleDeleteAttribute} // أضف هذا
          onUpdateAttribute={handleUpdateAttribute} // أضف هذا
        />

        {/* Variants Section */}
        {formData?.hasAttributes && (
          <VariantSection
            variants={formData?.variants}
            attributes={formData?.attributes}
            onAddVariant={handleAddVariant}
            onDeleteVariant={handleDeleteVariant}
            onUpdateVariant={handleUpdateVariant}
          />
        )}

        {/* Form Actions */}
        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="mr-2 ml-2 px-4 py-2 border rounded hover:bg-gray-100"
          >
            {t("cancel_button")}
          </button>
          <Button
            type="submit"
            disabled={isLoadingAction}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-blue-400"
          >
            {isLoadingAction ? t("is_loading") : t("update")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditProduct;
